



















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<InputFileImage>({})
export default class InputFileImage extends Vue {
    @Prop(String) public value!: string
    @Prop(String) public label!: string
    @Prop(String) public id!: string

    public onChange(event: Event) {
        this.$emit('change', event)
    }
}
